/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'react-bootstrap/lib/Button';

import BikeCard from 'widgets/BikeCard';
import Preloader from 'widgets/Preloader';

import './SearchResults.css';

const SearchResults = ({
  t,
  currency,
  bikeTypes,
  isModerator,
  isFetching,
  items,
  canLoadMore,
  loadMore,
  onShowBikeOnMap,
  onSelect
}) => (
  <div className="search-results">
    <ul className="search-results-list">
      {!!isFetching && (
        <Preloader cubeStyle={{ backgroundColor: '#5080c5' }} />
      )}

      {(!isFetching && items && !items.length) && (
        <div className="search-results-empty">
          <h2>{t('Oops! Everything is booked on this dates')}</h2>
          <p>{t('Please leave your email below and we will contact you immediately if we will find something according to your search')}</p>
        </div>
      )}

      {(!!items && !!items.length) && items.map((bike) => (
        <li
          key={bike.id}
          className="search-results-item"
        >
          <BikeCard
            bike={bike}
            bikeTypes={bikeTypes}
            currency={currency}
            showBikeLocation={onShowBikeOnMap}
            showProvider={isModerator}
            onClick={onSelect}
          />
        </li>
      ))}
    </ul>

    {!!canLoadMore && (
      <Button
        bsStyle="success"
        disabled={isFetching}
        onClick={loadMore}
      >
        {t('Show more')}
      </Button>
    )}
  </div>
);

SearchResults.propTypes = {
  currency: PropTypes.string.isRequired,
  bikeTypes: PropTypes.array,
  isModerator: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  canLoadMore: PropTypes.bool.isRequired,
  loadMore: PropTypes.func.isRequired,
  onShowBikeOnMap: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

export default translate(['search', 'translation'])(SearchResults);



// WEBPACK FOOTER //
// ./src/components/SearchPage/SearchResults/SearchResults.js